// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-container[data-v-23246d25]{font-size:12px}.app-container div[data-v-23246d25],.app-container ol[data-v-23246d25],.app-container ul[data-v-23246d25]{padding:0 20px;text-align:left;line-height:30px}.app-container ol[data-v-23246d25],.app-container ul[data-v-23246d25]{list-style:decimal}", ""]);
// Exports
module.exports = exports;
